import { IBusinessLocation } from 'models';
import { IBusinessFaqQuestions } from 'parent-portal/home/Models/DashboardData';

interface ILocationFaqs {
    [key: string]: string;
}

export function useLocationRequirements({
    faqQuestions,
    businessLocation,
}: {
    faqQuestions: IBusinessFaqQuestions[];
    businessLocation: IBusinessLocation;
}) {
    const locationFaqsAnswered = {} as ILocationFaqs;

    businessLocation.business.business_faqs
        .filter((faq) => faq.answer)
        .forEach((faq) => {
            locationFaqsAnswered[faq.question.id] = faq.answer;
        });
    businessLocation.business_faqs
        .filter((faq) => faq.answer)
        .forEach((faq) => {
            locationFaqsAnswered[faq.question] = faq.answer;
        });

    const locationFaqsAnsweredSet = new Set(Object.keys(locationFaqsAnswered));

    const unansweredFaqQuestions = faqQuestions.filter((faq) => {
        return !locationFaqsAnsweredSet.has(String(faq.id));
    });
    return unansweredFaqQuestions;
}
